"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeFirebaseError = void 0;
var general_1 = require("./general");
var decodeFirebaseError = function (error) {
    if ((0, general_1.objectIsEmpty)(error)) {
        return "An unexpected error occurred. Please try again.";
    }
    switch (error.code) {
        case "auth/user-not-found":
            return "No user found with this email address.";
        case "auth/wrong-password":
            return "Incorrect password. Please try again.";
        case "auth/invalid-email":
            return "Invalid email address format.";
        case "auth/too-many-requests":
            return "Too many login attempts. Please try again later.";
        case "auth/email-already-in-use":
            return "This email address is already in use. Please try a different one.";
        case "auth/weak-password":
            return "The password is too weak. Please choose a stronger password.";
        case "auth/operation-not-allowed":
            return "This operation is not allowed. Please contact support.";
        case "auth/expired-action-code":
            return "The action code has expired. Please request a new one.";
        case "auth/invalid-action-code":
            return "The action code is invalid. Please check the link and try again.";
        case "auth/invalid-verification-code":
            return "The verification code is invalid. Please check the code and try again.";
        case "auth/invalid-credential":
            return "The provided credential is invalid. Please check your input and try again.";
        case "auth/invalid-login-credentials":
            return "Invalid login credentials. Please check your email and password.";
        default:
            console.error("Unexpected Firebase error:", error);
            return "An unexpected error occurred. Please try again.";
    }
};
exports.decodeFirebaseError = decodeFirebaseError;
